import {
  useV2ListRateTablesForAccountQuery,
  useV2ListProjectVariablesQuery,
} from "@generated";
import type { ProjectVariableField } from "../types";

export interface RateTableOption {
  id: string;
  name: string;
}

// Loads the data needed to render the client form: the account's rate tables
// (for the "Preferred Rates" dropdown) and its client-context project variables
// (the dynamic user-defined fields).
export const useClientFormData = () => {
  const { data: rateTableData, isLoading: rateTablesLoading } =
    useV2ListRateTablesForAccountQuery({
      filter: { active: true },
      page: { size: 100 },
    });

  const { data: pvData, isLoading: pvLoading } = useV2ListProjectVariablesQuery(
    {
      filter: { "variable-context": "client", active: true },
      page: { size: 100 },
    }
  );

  const rateTables: RateTableOption[] = (rateTableData?.data ?? []).map(
    (rt) => ({
      id: String(rt.id),
      name: rt.attributes?.name ?? "",
    })
  );

  const projectVariables: ProjectVariableField[] = (pvData?.data ?? [])
    .map((pv) => ({
      name: pv.attributes?.name ?? "",
      label: pv.attributes?.label ?? pv.attributes?.name ?? "",
      variableType: pv.attributes?.variable_type ?? "text",
      required: pv.attributes?.required ?? false,
      minimum: pv.attributes?.minimum,
      maximum: pv.attributes?.maximum,
      selectOptions: (pv.attributes?.select_options ?? []).map((o) => ({
        key: o.key ?? "",
        value: o.value ?? "",
        default: o.default,
      })),
      position: pv.attributes?.position ?? 0,
    }))
    .sort((a, b) => a.position - b.position);

  return {
    rateTables,
    projectVariables,
    isLoading: rateTablesLoading || pvLoading,
  };
};

export default useClientFormData;
